import { Flex, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { SelectTime } from '../SelectTime/SelectTime';
import { useStandardScheduleOption } from './StandardScheduleOption.hooks';
import { messages } from './StandardScheduleOption.messages';
import { StandardScheduleOptionProps } from './StandardScheduleOption.types';

export const StandardScheduleOption = memo<StandardScheduleOptionProps>((props) => {
    const { ruleIndex } = props;

    const { value, handleChange } = useStandardScheduleOption(ruleIndex);

    return (
        <Flex container alignItems='center' data-qa='rule-schedule-time'>
            <Flex size={12} alignItems='center' spacing='8'>
                <Text font='label' color='midnight70' fontSize='small'>
                    {messages.sendReportAt}
                </Text>

                <SelectTime time={value} onChange={handleChange} />
            </Flex>
        </Flex>
    );
});

StandardScheduleOption.displayName = 'StandardScheduleOption';
